import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../hooks';
import { Icon } from '../Icon/Icon';
import { AvatarMultiple } from '../AvatarMultiple/AvatarMultiple';
import './Avatar.scss';
import { useIconSize } from './hooks/useIconSize';
import { useHasError } from './hooks/useHasError';
export const Avatar = ({ src, fallbackIcon, variant, size = 'medium', loading }) => {
    const [hasError, setHasError] = useHasError({ src });
    const iconSize = useIconSize({ size });
    const className = useClassName({ name: 'avatar', prefixed: true }, variant === 'circle' && 'circle', variant === 'square' && 'square', loading && 'loading', hasError && 'has-error', size);
    if (loading)
        return _jsx("div", { className: className });
    if (hasError || !src)
        return (_jsx("div", { className: className, children: _jsx(Icon, { color: 'neutral-300', name: fallbackIcon, size: iconSize }) }));
    return _jsx("img", { onError: () => setHasError(true), className: className, src: src });
};
Avatar.Multiple = AvatarMultiple;
